import {navInit} from './scripts/navigation';
import {sliderInit} from './scripts/sliders';
import {ddScrollSpy} from './scripts/ddscrollspy';
import {initMapScript} from './scripts/map';

sliderInit();
navInit();
ddScrollSpy();
initMapScript();


// var MenuSpy = require('menuspy');

// var elm = document.querySelector('#menu-header-menu');
// var ms = new MenuSpy(elm);
 
// import AOS from 'aos';
// import 'aos/dist/aos.css'; // You can also use <link> for styles
// import 'animate.css/animate.css';

// // ..
// AOS.init({
//   offset: 100, // offset (in px) from the original trigger point
//   delay: 50, // values from 0 to 3000, with step 50ms
//   duration: 500, // values from 0 to 3000, with step 50ms
//   easing: 'ease-in-out', // default easing for AOS animations
//   once: true, // whether animation should happen only once - while scrolling down
//   mirror: false,
// }); 


jQuery(document).ready(function ( $ ) {

  // Get page title
  var pageTitle = $("title").text();

	// Change page title on blur
	$(window).blur(function() {
	  $("title").text("Wróć do TopDruk!");
	});

	// Change page title back on focus
	$(window).focus(function() {
	  $("title").text(pageTitle);
	});

  

});

